module.exports = __webpack_public_path__ + "img/icn_info.40b86362.svg";